import React from "react";
import "../styles/experience.css";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { RiStarSFill } from "react-icons/ri";

const Experience = () => {
  return (
    <section id="experience">
      <h5>What I Know</h5>
      <h2>My Skills...</h2>
      <div className="container experience_container">
        <div className="frontend">
          <h3>Frontend Development</h3>
          <div className="skill-cards-container">
            <div className="skill-card">
              <BsFillPatchCheckFill className="skill-icon" />
              <div className="skill">
                <h4>HTML</h4>
                <small>
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star " />
                </small>
              </div>
            </div>
            <div className="skill-card">
              <BsFillPatchCheckFill className="skill-icon" />
              <div className="skill">
                <h4>CSS3</h4>
                <small>
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star silver" />
                </small>
              </div>
            </div>
            <div className="skill-card">
              <BsFillPatchCheckFill className="skill-icon" />
              <div className="skill">
                <h4>JAVASCRIPT</h4>
                <small>
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star silver" />
                </small>
              </div>
            </div>
            <div className="skill-card">
              <BsFillPatchCheckFill className="skill-icon" />
              <div className="skill">
                <h4>React JS</h4>
                <small>
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star " />
                  <RiStarSFill className="star silver" />
                </small>
              </div>
            </div>
            <div className="skill-card">
              <BsFillPatchCheckFill className="skill-icon" />
              <div className="skill">
                <h4>SASS</h4>
                <small>
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star silver" />
                </small>
              </div>
            </div>
            <div className="skill-card">
              <BsFillPatchCheckFill className="skill-icon" />
              <div className="skill">
                <h4>JQuery</h4>
                <small><RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star" />
                  <RiStarSFill className="star silver" />
                  <RiStarSFill className="star silver" />
                  </small>
              </div>
            </div>
          </div>
        </div>
        <div className="others">
          <h3>Other Languages</h3>
          <div className="skill-cards-container">
            <div className="skill-card">
              <BsFillPatchCheckFill className="skill-icon" />
              <div className="skill">
                <h4>Java</h4>
                <small>Aware</small>
              </div>
            </div>
            <div className="skill-card">
              <BsFillPatchCheckFill className="skill-icon" />
              <div className="skill">
                <h4>MySQL</h4>
                <small>Aware</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
